import React from "react";
import classnames from "classnames";

import { Info } from "components/Icons";
import { FormattedMessage, injectIntl } from "react-intl";

import "./style.scss";
import ToolTip from "components/ToolTip";

const Input = ({
  input = {},
  meta = { touched: false, error: null },
  label = "",
  hasTooltip = false,
  tooltipText = "",
  containerClassName = "",
  value = "" as string | number,
  placeholder = "",
  intl: { formatMessage },
  isEditOrCreate = true,
  ...props
}) => {
  const placeholderText = placeholder ? formatMessage({ id: placeholder }) : "";
  const formattedToolTip = tooltipText
    ? formatMessage({ id: tooltipText })
    : "";
  const style = {
    removeOutline: {
      border: "1px solid transparent",
      outline: "none",
      backgroundColor: "transparent",
      opacity: 1,
    },
  };
  return (
    <div
      className={classnames("cnb-input", containerClassName, {
        error: meta.touched && meta.error,
      })}
    >
      {hasTooltip && (
        <div className="label-container">
          {label && <FormattedMessage id={label} tagName="label" />}
          <ToolTip content={formattedToolTip}>
            <Info />
          </ToolTip>
        </div>
      )}
      {label && !hasTooltip && label && (
        <FormattedMessage id={label} tagName="label" />
      )}
      <input
        value={value}
        placeholder={isEditOrCreate ? placeholderText : ""}
        {...input}
        {...props}
        style={isEditOrCreate ? {} : style.removeOutline}
      />
      {meta.touched && meta.error && <span>{meta.error}</span>}
    </div>
  );
};

export default injectIntl(Input);
